import { makeStyles } from '@material-ui/core/styles';
import typography from '@/theme/typography';
import { TextColors, TextOpacities, SecondaryColors } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  root: {
    '& $pagination': {
      '& .MuiPaginationItem-root': {
        color: hexToRGBA(TextColors.light, TextOpacities.light1),
      },

      '& .Mui-selected': {
        color: SecondaryColors.main,
      },
    },
    '& $noResultsMessage': {
      color: TextColors.light,
    },
    '& $noResultsCta': {
      color: TextColors.light,
    },
  },
};

const lightTheme = {
  root: {
    '& $pagination': {
      '& .MuiPaginationItem-root': {
        color: hexToRGBA(TextColors.dark, TextOpacities.dark1),
      },

      '& .Mui-selected': {
        color: SecondaryColors.dark,
      },
    },
    '& $noResultsMessage': {
      color: TextColors.dark,
    },
    '& $noResultsCta': {
      color: TextColors.dark,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      alignContent: 'center',
      width: '100%',

      '&:not(.is-grid)': {
        '& $resultsContainer': {
          maxWidth: 895,
        },
      },
    },
    grid: {
      '&.MuiGrid-root': {
        [muiTheme.breakpoints.down('sm')]: {
          marginLeft: '-32px',
          marginRight: '-32px',
          width: 'calc(100% + 64px)',

          '& > .MuiGrid-item': {
            paddingLeft: 0,
            paddingRight: 0,
          },
        },
      },
    },
    block: {
      animation: 'enter 250ms ease-out',
      wordBreak: 'break-word',

      '& > a': {
        height: '100%',

        '& > *': {
          height: '100%',
        },
      },
    },
    content: {
      '&:not(:last-child)': {
        marginBottom: muiTheme.spacing(2),
      },
      [muiTheme.breakpoints.down('xs')]: {
        width: '100%',
        overflow: 'hidden',
      },
    },
    tags: {},
    topResults: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      alignContent: 'flex-start',
      flexWrap: 'wrap',
      marginBottom: muiTheme.spacing(2.5),

      [muiTheme.breakpoints.up('md')]: {
        marginBottom: muiTheme.spacing(5),
      },
    },
    resultsContainer: {},
    spacer: {
      flexGrow: 1,

      [muiTheme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    sortBy: {
      marginRight: '-9px',
      marginTop: '2px',
    },
    pagination: {
      marginTop: muiTheme.spacing(3),

      '& .MuiPagination-ul': {
        justifyContent: 'center',

        [muiTheme.breakpoints.up('md')]: {
          justifyContent: 'flex-end',
          margin: '0 -14px',
        },
      },

      '& .MuiPaginationItem-root': {
        ...typography.body1,
      },

      '& .Mui-selected': {
        background: 'transparent',
      },
    },
    noResults: {
      textAlign: 'center',
      padding: muiTheme.spacing(3, 0),
    },
    noResultsMessage: {},
    noResultsCta: {},
    filtersContainer: {
      display: 'none',

      [muiTheme.breakpoints.up('md')]: {
        display: 'block',
      },

      '& > .filters__wrapper': {
        marginBottom: muiTheme.spacing(2),
      },
    },
  }),
  { name: 'GenFilteredListResults' },
);

export default useStyles;
